import { Fragment, useContext, useEffect, useState } from "react"
import { Button, Form, OverlayTrigger, Tooltip } from "react-bootstrap";
import { ExploreSearchContext, removeFilter, addFilter, FilterSpec, FilterType, FilterValue, heartFilter } from "../states/ExploreSearchState";
import { FaRegTimesCircle } from "react-icons/fa";
import { BsChevronRight, BsFillPinAngleFill, BsHeartFill, BsTrashFill } from "react-icons/bs";
import { Localization } from "@viamap/viamap2-common";
import { MitStorage } from "src/managers/MitStorage";
import { MapitStateContext } from "src/states/MapitState";
import { LayerInfo, LayerType, LayerVariabilityType } from "src/common/managers/Types";

import { ApplicationStateContext } from "src/states/ApplicationState";
import { GlassCard, GlassCheckbox, GlassList } from "src/components/MitGlassComponents";
import { GlassInputControl } from "./GlassInput";
import union from "@turf/union";

export function Filters() {
   let { state } = useContext(ExploreSearchContext);

   const { hasAccessToFeature } = useContext(ApplicationStateContext);

   let [saves, setSave] = useState<null | boolean>(null)

   function doSave() {
      if (saves ?? (MitStorage.getValue(state.searchStorageKey) || "{}") !== "{}") {
         // TODO: Save to userSettings
         MitStorage.setValue(state.searchStorageKey, {})
         setSave(false)
      } else {
         MitStorage.setValue(state.searchStorageKey, state.activeFilters)
         setSave(true)
      }
   }

   useEffect(() => {
      if (saves ?? (MitStorage.getValue(state.searchStorageKey) || "{}") !== "{}") {
         // TODO: Save to userSettings
         MitStorage.setValue(state.searchStorageKey, state.activeFilters)
         setSave(true)
      } else {
         setSave(false)
      }

   }, [state.activeFilters])

   useEffect(() => {
      // TODO: Save to userSettings
      MitStorage.setValue(state.favoriteSearchesStorageKey, state.favoritFilters)
   }, [state.favoritFilters])

   function hearted(key: string) {
      return state.favoritFilters.includes(key) ? 1 : 0;
   }

   function filterByAccessRight(key: string): boolean {
      let filterSpec = state.selectableFilterList[key];
      return !filterSpec.licenseFeature || hasAccessToFeature(filterSpec.licenseFeature);
   }


   return (
      <GlassCard
         variant={"FilterList"}
         title={<>{Localization.getText("Filters")}
            <BsFillPinAngleFill style={{ marginLeft: "auto" }} title={(saves ?? (MitStorage.getValue(state.searchStorageKey) || "{}") !== "{}") ? Localization.getText("Reset active filter between sessions") : Localization.getText("Store active filter between sessions")} color={(saves ?? (MitStorage.getValue(state.searchStorageKey) || "{}") !== "{}") ? "#c78e57" : "#cbcbce"} onClick={doSave} />
         </>}
      >
         <>

            {Object.keys(state.selectableFilterList).filter(filterByAccessRight).sort((a, b) => hearted(b) - hearted(a)).map((item) => {
               let value = state.selectableFilterList[item];
               let selected: boolean = Object.keys(state.activeFilters).includes(item);
               return (
                  <Fragment key={item} >
                     <FilterItem
                        item={item}
                        value={value}
                        selected={selected}
                        active={state.activeFilters[item]}
                     />
                  </Fragment>
               )
            })
            }
         </>
      </GlassCard>
   )
}

function FilterItem(props: { item: string, selected: boolean, value: FilterSpec, active: FilterValue }) {
   let [open, setOpen] = useState(false)
   let { state, dispatch } = useContext(ExploreSearchContext);

   function handleHeart(e) {
      e.preventDefault();
      e.stopPropagation()
      dispatch(heartFilter(props.item, !(state.favoritFilters.includes(props.item))))
   }

   return props.value.hideOnFilterList ? null : (
      <GlassList onClick={() => setOpen(!open)}
         variant={open ? "open" : ""}
         title={
            <>
               <span className='mit-transformer' style={{ paddingLeft: "1px", transform: "Rotate(" + (open ? "90deg" : "0deg") + ")" }}><BsChevronRight /></span>
               <span style={{ flex: "100% 1", overflow: "hidden", textOverflow: "ellipsis" }}>
                  {Localization.getTextSpecificTable(props.value.title, props.value.translationTable)}
               </span>
               <BsHeartFill onClick={handleHeart}
                  title={state.favoritFilters.includes(props.item) ? Localization.getText("Undo favorite") : Localization.getText("Make favorite")}
                  color={state.favoritFilters.includes(props.item) ? "#45465b" : "#cbcbce"} style={{ margin: "6px", marginTop: "9px", marginLeft: "auto" }} />
            </>
         }
      >
         {open ?
            <FilterItemS {...props} activeOnly={!open} />
            : null}
      </GlassList>
      // <button key={props.item} data-active={props.selected}
      //    onClick={() => {
      //       if (props.selected) {
      //          dispatch(removeFilter(props.item));
      //       } else {
      //          // let spec = state.selectableFilterList[props.item];  
      //          dispatch(addFilter(props.item, undefined));
      //       };
      //    }}
      // >
      //    {props.value.title} 
      // </button>
   );
}


function FilterTitleClickable(props: { item: string, title: string }) {
   let { dispatch } = useContext(ExploreSearchContext);
   const { item, title } = props;
   let placement = "top";
   return (
      <div style={{ display: "inline-block" }}>
         <OverlayTrigger
            key={placement}
            overlay={
               <Tooltip id={`tooltip-${placement}`}>
                  Tryk for at fjerne dette filter
               </Tooltip>
            }
         >
            <Button size="sm" variant="light" onClick={() => { dispatch(removeFilter(item)); }}>
               <FaRegTimesCircle style={{ verticalAlign: "baseline" }} />{' '}{title}
            </Button>
         </OverlayTrigger>
      </div>
   );
}


function FilterItemSSelect(props: { item: string, value: string, spec: FilterSpec, active: FilterValue, activeOnly?: boolean }) {
   let { state, dispatch } = useContext(ExploreSearchContext);
   let { item, spec, active, activeOnly } = props;
   let val = state.activeFilters[item] || [];

   function setValue(item: string, value: any) {
      if ((active as string[])?.includes(value)) {
         dispatch(removeFilter(item))
      } else {
         dispatch(addFilter(item, [value]))
      }
   }

   if (activeOnly && (!val || val.length < 1)) {
      return null
   }

   return (
      <Form onSubmit={(e) => e.preventDefault()}>
         <Form.Group className="long">
            {spec.options && Object.keys(spec.options).map((key) => {
               let text = spec.options && spec.options[key];
               if (text && spec.translateOptions) {
                  text = Localization.getTextSpecificTable(text, spec.translationTable);
               }
               if (activeOnly && !((active as string[])?.includes(key))) {
                  return null
               }
               return (
                  <div key={key} className="FilterCheckBoxLine">
                     <GlassCheckbox type="checkbox" checked={!!((active as string[])?.includes(key))} onChange={() => { setValue(item, key) }} />
                     <span className="FilterCheckboxLabel">{text}</span>
                  </div>
               );
            })}
         </Form.Group>
      </Form>
   );
}


function FilterItemSelect(props: { item: string, value: string, spec: FilterSpec, active: FilterValue, activeOnly?: boolean }) {
   let { state, dispatch } = useContext(ExploreSearchContext);
   let { item, value, spec, active, activeOnly } = props;
   let val = state.activeFilters[item] || [];

   const groups = {
      "0": "Helårsbeboelse", //"Bygninger til Helårsbeboelse",
      "210": "Landbrug, gartneri, skovbrug og fiskeri", //"Bygning til erhvervsmæssig produktion vedrørende landbrug, gartneri, skovbrug og fiskeri",
      "220": "Industri og værksteder", //"Bygninger til erhvervsmæssig produktion vedrørende industri og værksteder",
      "230": "Energiproduktion og energidistribution", //"Bygninger vedrørende energiproduktion og energidistribution",
      "310": "Transport og parkering", //"Bygninger i forbindelse med transport og parkering",
      "320": "Kontor, handel og lager", //"Bygninger i forbindelse med kontor, handel og lager",
      "330": "Hotel, restaurant og øvrige serviceerhverv", //"Bygninger i forbindelse med hotel, restaurant og øvrige serviceerhverv",
      "410": "Biograf, bibliotek og trosudøvelse", //"Bygninger i forbindelse med biograf, bibliotek og trosudøvelse",
      "420": "Undervisning og forskning", //"Bygninger i forbindelse med undervisning og forskning",
      "430": "Hospitaler, hospicer og lægehuse", //"Bygninger i forbindelse med hospitaler, hospicer og lægehuse",
      "440": "Dag- og døgninstitutioner", //"Bygninger i forbindelse med dag- og døgninstitutioner",
      "510": "Fritidsformål og idræt", //"Bygninger til fritidsformål og idræt",
      "910": "Garageformål, ophold og opbevaring samt faldefærdig bygning", //"Mindre bygninger til garageformål, ophold og opbevaring samt faldefærdig bygning",
      "1000": "test"
   } as const
   let groupList = Object.keys(groups).map((a) => parseInt(a))

   function setValue(item: string, value: any) {

      if ((active as string[])?.includes(value)) {
         if (active!.length <= 1) {
            dispatch(removeFilter(item))
         }
         dispatch(addFilter(item, active!.filter((a) => a != value)));
      } else {
         dispatch(addFilter(item, [...(active || []), value]))
      }
   }

   if (activeOnly && (!val || val.length < 1)) {
      return null
   }

   if (spec.title === "Building Usage") {
      return (<>{Object.keys(groups).map((a, i) => {
         if (a === "1000") {
            return null
         }
         return (
            <Fragment key={a}>
               <BuildingUsageGroup item={props.item} value={value} spec={props.spec} setValue={setValue} active={props.active} activeOnly={props.activeOnly} min={groupList[i]} max={groupList[i + 1]} groups={groups} />
            </Fragment>
         )
      })}</>)
   }

   return (
      <Form onSubmit={(e) => e.preventDefault()}>
         <Form.Group className="long">
            {spec.options && Object.keys(spec.options).map((key) => {
               let text = spec.options && spec.options[key];
               if (text && spec.translateOptions) {
                  text = Localization.getTextSpecificTable(text, spec.translationTable);
               }
               if ((!open || props.activeOnly) && !((props.active as string[])?.includes(key))) {
                  return null
               }
               return (
                  <div key={key} className="FilterCheckBoxLine">
                     <GlassCheckbox type="checkbox" checked={!!((active as string[])?.includes(key))} onChange={() => { setValue(item, key) }} />
                     <span className="FilterCheckboxLabel">{text}</span>
                  </div>
               );
            })}
         </Form.Group>
      </Form>
   );
}

function FilterItemS(props: { item, value, selected, active, activeOnly }) {
   let { item, value, active, activeOnly } = props; // as {key:string, value:string}
   let { state } = useContext(ExploreSearchContext);

   let spec: FilterSpec = state.selectableFilterList[item];
   // check the type of the filter
   switch (spec.filterType) {
      case FilterType.SingleSelect:
         return (
            <FilterItemSSelect item={item} value={value} spec={spec} active={active} activeOnly={activeOnly} />
         )
      case FilterType.Select:
      case FilterType.IntegerSet:
      case FilterType.SelectText:
      case FilterType.SelectTextList:
         return (
            <FilterItemSelect item={item} value={value} spec={spec} active={active} activeOnly={activeOnly} />
         );
      case FilterType.IntegerRange:
         return (
            <FilterItemIntegerRange item={item} value={value} spec={spec} activeOnly={activeOnly} />
         );
      case FilterType.DateRange:
         return (
            <FilterItemDateRange item={item} value={value} spec={spec} activeOnly={activeOnly} />
         );
      case FilterType.String:
      case FilterType.Integer:
         return (
            <FilterItemSingleValue item={item} value={value} spec={spec} activeOnly={activeOnly} />
         );
      case FilterType.StaticValue:
      case FilterType.BoundingBox:
         return (
            <>
               <FilterTitleClickable item={item} title={Localization.getTextSpecificTable(spec.title, spec.translationTable)} />
               {JSON.stringify(value).substring(0, 50)}
            </>
         );
      case FilterType.Polygon:
         return (<></>);

      case FilterType.PolygonFromLayer:
         return (
            <FilterSelectMapLayer item={item} value={value} spec={spec} activeOnly={activeOnly} />
         )
      default:
         return (
            <div>Unexpected filter type {spec.filterType}</div>
         );
   }
}

function BuildingUsageGroup(props: { item: string, value: string, spec: FilterSpec, setValue: (a, b) => void, active: FilterValue, activeOnly?: boolean, min: number, max: number, groups: any }) {
   let { dispatch } = useContext(ExploreSearchContext);
   let [open, setOpen] = useState(false)

   let allInGroup = (Object.keys((props.spec?.options || {})).filter((a) => parseInt(a) >= props.min && parseInt(a) < props.max) || [])
   let activeInGroup = (props.active?.filter((a) => a >= props.min && a < props.max) || [])
   let inActiveInGroup = (allInGroup.filter((a) => !activeInGroup.includes(a)))
   if (props.activeOnly && activeInGroup.length === 0) {
      return null
   }
   let spec = props.spec

   function ClickCheck() {
      if (inActiveInGroup.length > 0) {
         dispatch(addFilter(props.item, [...(props.active || []), ...inActiveInGroup]))
      } else {
         dispatch(addFilter(props.item, (props.active || []).filter((a) => !allInGroup.includes(a))))
      }
   }


   return (
      <GlassList
         variant={open ? "open" : ""}
         onClick={() => setOpen(!open)}
         title={
            <>
               <GlassCheckbox checked={activeInGroup.length > 0} onClick={(e) => { ClickCheck(); e.stopPropagation(); e.preventDefault() }} />
               <div style={{ position: "relative" }} >{props.groups[props.min.toString()]}<span className='mit-transformer' style={{ position: "absolute", marginLeft: "8px", transform: "Rotate(" + (open ? "90deg" : "0deg") + ")" }}><BsChevronRight /></span></div>
            </>
         }
      >

         {spec.options && Object.keys(spec.options).filter((a) => parseInt(a) >= props.min && parseInt(a) < props.max).map((key) => {
            let text = spec.options && spec.options[key];
            if (text && spec.translateOptions) {
               text = Localization.getTextSpecificTable(text, spec.translationTable);
            }
            if ((!open || props.activeOnly) && !((props.active as string[])?.includes(key))) {
               return null
            }
            return (
               <div key={key} className="FilterCheckBoxLine">
                  <GlassCheckbox style={{ fontWeight: "300" }} checked={!!((props.active as string[])?.includes(key))} onChange={() => { props.setValue(props.item, key) }} />
                  <span className="FilterCheckboxLabel ">{text}</span>
               </div>
            );
         })}
      </GlassList>
   )
}

function FilterItemIntegerRange(props: { item: string, value: string, spec: FilterSpec, activeOnly: boolean }) {

   let { state, dispatch } = useContext(ExploreSearchContext);
   let { item, activeOnly } = props;
   let val = state.activeFilters[item];
   let [minValue, setMinValue] = useState<string>((val && val[0]) || "");
   let [maxValue, setMaxValue] = useState<string>((val && val[1]) || "");

   function setValue(item: string, value: FilterValue) {
      dispatch(addFilter(item, value));
   }

   useEffect(() => {
      setMinValue(state.activeFilters?.[item]?.[0] || "")
      setMaxValue(state.activeFilters?.[item]?.[1] || "")
   }, [state.activeFilters])

   function handleTrash(item, value) {
      setMinValue(value[0]);
      setMaxValue(value[1]);
      if (value[0] || value[1]) {
         setValue(item, value)
      } else {
         dispatch(removeFilter(item))
      }
   }

   function handleMinValue(item: string, value: any) {
      setValue(item, [value, maxValue])
      setMinValue(value)
   }

   function handleMaxValue(item: string, value: any) {
      setValue(item, [minValue, value])
      setMaxValue(value)
   }

   if (activeOnly && (!val || val.length < 1 || !val.some((a) => !!a))) {
      return null
   }

   return (
      <Form onSubmit={(e) => e.preventDefault()}>
         {activeOnly && !minValue ? null : <Form.Group className={!minValue ? "" : "hV"}>
            <Form.Control size="sm" value={minValue} onChange={(e) => { handleMinValue(props.item, e.target.value) }} />
            <BsTrashFill onClick={() => handleTrash(item, ["", maxValue])} />
         </Form.Group>}
         {/* <span style={{float:"left"}}>{" < "}</span> */}
         {activeOnly && !maxValue ? null : <Form.Group className={!maxValue ? "" : "hV"}>
            <Form.Control size="sm" value={maxValue} onChange={(e) => { handleMaxValue(props.item, e.target.value) }} />
            <BsTrashFill onClick={() => handleTrash(item, [minValue, ""])} />
         </Form.Group>}
      </Form>
   );
}

function FilterItemDateRange(props: { item: string, value: string, spec: FilterSpec, activeOnly }) {
   let { state, dispatch } = useContext(ExploreSearchContext);
   let { item, activeOnly } = props;
   let val = state.activeFilters[item];
   let [minValue, setMinValue] = useState<string>((val && val[0]) || "");
   let [maxValue, setMaxValue] = useState<string>((val && val[1]) || "");

   function setValue(item: string, value: FilterValue) {
      dispatch(addFilter(item, value));
   }

   useEffect(() => {
      setMinValue(state.activeFilters?.[item]?.[0] || "")
      setMaxValue(state.activeFilters?.[item]?.[1] || "")
   }, [state.activeFilters])

   function handleMinValue(item: string, value: any) {
      setValue(item, [value, maxValue])
      setMinValue(value)
   }

   function handleTrash(item, value) {
      setMinValue(value[0]);
      setMaxValue(value[1]);
      if (value[0] || value[1]) {
         setValue(item, value)
      } else {
         dispatch(removeFilter(item))
      }
   }

   function handleMaxValue(item: string, value: any) {
      setValue(item, [minValue, value])
      setMaxValue(value)
   }

   if (activeOnly && (!val || val.length < 1 || !val.some((a) => !!a))) {
      return null
   }

   return (
      <Form onSubmit={(e) => e.preventDefault()}>
         {activeOnly && !minValue ? null : <Form.Group className={!minValue ? "" : "hV"}>
            <Form.Control className={!minValue ? "" : "hV"} type="date" size="sm" value={minValue} onChange={(e) => { handleMinValue(item, e.target.value) }} />
            <BsTrashFill onClick={() => handleTrash(item, ["", maxValue])} />
         </Form.Group>}
         {/* <span style={{float:"left"}}>{" < "}</span> */}
         {activeOnly && !maxValue ? null : <Form.Group className={!maxValue ? "" : "hV"}>
            <Form.Control className={!maxValue ? "" : "hV"} type="date" size="sm" value={maxValue} onChange={(e) => { handleMaxValue(item, e.target.value) }} />
            <BsTrashFill onClick={() => handleTrash(item, [minValue, ""])} />
         </Form.Group>}
      </Form>
   );
}

function FilterItemSingleValue(props: { item: string, value: string, spec: FilterSpec, activeOnly: boolean }) {
   let { state, dispatch } = useContext(ExploreSearchContext);
   let { item, activeOnly } = props;
   let val = state.activeFilters[item];
   let [fieldValue, setFieldValue] = useState<string>((val && val[0]) || "");

   useEffect(() => {
      setFieldValue(state.activeFilters?.[item]?.[0] || "")
   }, [state.activeFilters])

   function setValue(item: string, value: FilterValue) {
      dispatch(addFilter(item, value));
   }

   function handleTrash(item, value) {
      setFieldValue(value[0]);
      if (value[0]) {
         setValue(item, value)
      } else {
         dispatch(removeFilter(item))
      }
   }

   if (activeOnly && (!val || val.length < 1)) {
      return null
   }

   return (
      <Form onSubmit={(e) => e.preventDefault()}>
         <Form.Group className={!val ? "" : "hV"} onBlur={() => { setValue(item, [fieldValue]) }}>
            <Form.Control size="sm" value={fieldValue} onChange={(e) => { setFieldValue(e.target.value) }} />
            <BsTrashFill onClick={() => handleTrash(item, [""])} />
         </Form.Group>
      </Form>
   );
}

function FilterSelectMapLayer(props: { item: string, value: string, spec: FilterSpec, activeOnly: boolean }) {
   let { state, dispatch } = useContext(ExploreSearchContext);
   let { item, activeOnly } = props;
   const { state: mapitState } = useContext(MapitStateContext);
   const [availableLayers, setAvailableLayers] = useState<any>([]);
   const [selectedLayerId, setSelectedLayerId] = useState<number>();

   let val = state.activeFilters[item];
   let [fieldValue, setFieldValue] = useState<string>((val && val[0]) || "");

   useEffect(() => {
      setFieldValue(state.activeFilters?.[item]?.[0] || "")
      if (!Object.keys(state.activeFilters).includes("map_layer")) {
         setSelectedLayerId(undefined);
      }
   }, [state.activeFilters])

   function setValue(item: string, value: FilterValue) {
      dispatch(addFilter(item, value));
   }

   useEffect(() => {
      let relevantLayers = Object.values(mapitState.layers).filter((layerInfo: LayerInfo) => { return layerInfo.type === LayerType.GeoJSON_Polygon && ((layerInfo.layerVariability || LayerVariabilityType.NormalLayer) === LayerVariabilityType.NormalLayer) });
      let relevantLayerKeys = relevantLayers.map((lr) => { return lr.layerId }).sort();
      let availableLayerKeys = availableLayers.map((lr) => { return lr.layerId }).sort();
      // only update if there are new layers - not on any (e.g. data or styling change)
      if (!(relevantLayerKeys + "" === availableLayerKeys + "")) {
         setAvailableLayers(relevantLayers);
         setSelectedLayerId(undefined);
      }

   }, [mapitState.layers]);


   if (!(availableLayers?.length)) {
      return activeOnly ? (<></>) : (<div >{Localization.getText("No suitable Area Layers")}</div>);
   }

   function SelectLayer(props: { title: string, onSelect: (value: number | undefined) => void }) {
      return (
         <>
            <select onChange={e => {
               let layerId: number | undefined = Number.parseInt(e.target.value);
               if (Number.isNaN(layerId)) {
                  layerId = undefined;
               }
               props.onSelect(layerId);
            }}
               className="form-control input-sm"
               value={selectedLayerId}>
               <option key={"default"} value={""} >{Localization.getText("PointSource:ChooseALayer")}</option>
               {availableLayers.map((layerInfo: LayerInfo) => {
                  return (
                     <option key={layerInfo.layerId} value={layerInfo.layerId}>{layerInfo.datasetname}</option>
                  );
               })}
            </select>
         </>
      )
   }



   function callbackOnUserPolygon(poly: any) {
      // alert("Got polygon callback "+JSON.stringify(poly));
      let feature = poly.features[0]
      if (poly && poly.features && poly.features.length > 1) {
         feature = union(poly)
      }
      dispatch(addFilter("map_layer", feature?.geometry?.coordinates || []));
   }

   return (
      <Form onSubmit={(e) => e.preventDefault()}>
         <Form.Group className={!val ? "" : "hV"} onBlur={() => { setValue(item, [fieldValue]) }}>
            <SelectLayer
               title={Localization.getText("MultiPointDataLayer")}
               onSelect={(layerId: any) => {
                  setSelectedLayerId(layerId);
                  let found = availableLayers.find((lr) => lr.layerId === layerId);
                  if (found && found.geoJson) {
                     callbackOnUserPolygon(found.geoJson);
                  } else {
                     dispatch(removeFilter(item))
                  }
               }}
            />
            {/* <Form.Control size="sm" value={fieldValue} style={{ display: "inline-block", maxWidth: "8vw" }} onChange={(e) => { setFieldValue( e.target.value) }}  />
            <BsTrashFill onClick={(e) => handleTrash(item,[""])} /> */}
         </Form.Group>
      </Form>
   );
}

export const SelectColumn = (props: { disAllowDefault?: boolean, defaultText?: string, title: string, columns: string[], sKey: string, onSelect: (value: string) => void }) => {

   const hasSelection = !!props.sKey;

   return (
      <>
         <GlassInputControl>
            <select onChange={e => {
               props.onSelect(e.target.value);
            }}
               className={"form-control input-sm " + (props.disAllowDefault && !props.sKey ? "invalid" : "")}
               style={{ width: "auto", color: hasSelection ? undefined : "#888" }}
               value={props.sKey}>
               {!props.disAllowDefault && <option key={"default"} value={""} style={{ color: "#888" }}>{props.defaultText ?? Localization.getText("Use default")}</option>}
               {props.disAllowDefault && !props.sKey && <option key={"default"} value={""} style={{ color: "#888" }}>{Localization.getText("Choose field")}</option>}
               {props.columns && props.columns?.map((property) => {
                  return (
                     <option key={"" + property} value={property} style={{ color: "#000" }}>{property}</option>
                  )
               })}
            </select>
         </GlassInputControl>
      </>
   )
}

export const SelectLayer = (props: { selectedLayerId: number | "", availableLayers: LayerInfo[], title?: string, onSelect: (value: number | undefined) => void }) => {
   const hasSelection = props.selectedLayerId !== "" && props.selectedLayerId !== undefined;

   return (
      <>
         <GlassInputControl>
            <select onChange={e => {
               let layerId: number | undefined = Number.parseInt(e.target.value);
               if (Number.isNaN(layerId)) {
                  layerId = undefined;
               }
               props.onSelect(layerId);
            }}
               // className="form-control input-sm"
               style={{ width: "auto", color: hasSelection ? undefined : "#888" }}
               value={props.selectedLayerId}>
               <option key={"default"} value={""} style={{ color: "#888" }}>{Localization.getText("PointSource:ChooseALayer")}</option>
               {props.availableLayers.map((layerInfo: LayerInfo) => {
                  return (
                     <option key={layerInfo.layerId} value={layerInfo.layerId} style={{ color: "#000" }}>{layerInfo.datasetname}</option>
                  );
               })}
            </select>
         </GlassInputControl>
      </>
   )
}